import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsServerfaultComponent } from './simple-icons-serverfault.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsServerfaultComponent ],
    exports:      [ SimpleIconsServerfaultComponent ],
    bootstrap:    []
})
export class SimpleIconsServerfaultModule {}
